import { Component, HostBinding, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

const youtubeConf = require('src/assets/youtube.json');

const pictureSetMock: PictureSet[] = [
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle.png',
        activePic: '/assets/pictures/Rectangle_color.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-1.png',
        activePic: '/assets/pictures/Rectangle_color-1.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-2.png',
        activePic: '/assets/pictures/Rectangle_color-2.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-3.png',
        activePic: '/assets/pictures/Rectangle_color-3.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-4.png',
        activePic: '/assets/pictures/Rectangle_color-4.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-5.png',
        activePic: '/assets/pictures/Rectangle_color-5.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-6.png',
        activePic: '/assets/pictures/Rectangle_color-6.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-7.png',
        activePic: '/assets/pictures/Rectangle_color-7.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-8.png',
        activePic: '/assets/pictures/Rectangle_color-8.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-9.png',
        activePic: '/assets/pictures/Rectangle_color-9.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-10.png',
        activePic: '/assets/pictures/Rectangle_color-10.png'
    },
    {
        isHover: false,
        passivePic: '/assets/pictures/Rectangle-11.png',
        activePic: '/assets/pictures/Rectangle_color-11.png'
    }
];

@Component({
    selector: 'app-container',
    templateUrl: './container.component.html',
    styleUrls: ['./container.component.scss']
})
export class ContainerComponent implements OnInit {
    @HostBinding('class') classes = 'row';
    public block1 = false;
    public block2 = false;
    public block3 = false;
    public block4 = false;
    public pictureSet: PictureSet[];
    private isBlock2Started = false;
    public youTubeUrl: any;

    constructor(private sanitizer: DomSanitizer) {
    }

    ngOnInit() {
        this.youTubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(youtubeConf.url);
        console.log(this.youTubeUrl);
        this.pictureSet = pictureSetMock;
    }

    public startAnimation(block: string) {
        switch (block) {
            case 'block2':
                if (!this.isBlock2Started) {
                    this.block2 = true;
                    setInterval(() => {
                        this.isBlock2Started = true;
                        this.block2 = !this.block2;
                    }, 2200);
                } else {
                    return;
                }
                break;
            default:
                break;
        }
    }
}


interface PictureSet {
    isHover: boolean;
    passivePic: string;
    activePic: string;
}
